import { hasCriticalErrors } from '@/lib/utils';
import { isDealItemCategoryUpdating } from '@/lib/utils/updating-fields';
import { effectiveValidationErrorsAtom } from '@/states/effective-validation-errors.state';
import { productsState } from '@/states/products.state';
import { atom } from 'jotai';

const validSelectedProductsAtom = atom((get) => {
  const products = get(productsState);
  const effectiveErrors = get(effectiveValidationErrorsAtom);
  const selectedProducts = products.filter(
    (item) => item.activeVersion.isSelected
  );

  const validProducts = selectedProducts.filter((item) => {
    if (isDealItemCategoryUpdating(item)) return false;
    const errors = effectiveErrors.get(item.id);
    if (errors == null) return false;
    return !hasCriticalErrors(errors);
  });

  return { selectedProducts, validProducts };
});

export const completionPercentageAtom = atom<number>((get) => {
  const { selectedProducts, validProducts } = get(validSelectedProductsAtom);

  if (selectedProducts.length === 0) {
    return 0;
  }

  return Math.round((validProducts.length / selectedProducts.length) * 100);
});

export const completedCountAtom = atom<number>((get) => {
  const { selectedProducts, validProducts } = get(validSelectedProductsAtom);

  if (selectedProducts.length === 0) {
    return 0;
  }

  return validProducts.length;
});
